export default __webpack_public_path__ + "static/media/brand8.2eacf34b.svg";